import React from 'react'
import '.././assets/css/portfolio.css'
function ProjectList({title , desc , skills , url}) {
  return (
      <div className="project">
        <h4>{title}</h4>

        <div className="projectcard">
            <p>{desc}</p>
            <button>
             <a href={url} target="_blank">   View Project</a>
            </button>
        </div>

        <div className="pro-skills">
          
                     {skills.map((item, i) => (
          <span
            key={i}
            className="text-xs bg-[#1A1A1A] border border-[#333] px-3 py-1 rounded-full text-gray-300"
          >
            {item}
          </span>
        ))}
            </div>
        
      </div>
  )
}

export default ProjectList
